import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyBoiledLolliesIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./BoiledLolliesIcon-bef2fb10.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyBoiledLolliesIcon as P };
